import React, { type FC, useEffect } from 'react'

import { useIntl } from 'react-intl'

import {
  Flex,
  LINK_VARIANT_HIGHLIGHT,
  Link,
  MESSAGE_BOX_VARIANT_HELP,
  MessageBox,
  Panel,
  TITLE_VARIANT_M,
  Title,
  TooltipUtils,
} from 'mailup-web-components'

import { notifyParent } from 'mailup-react-helpers'

const EmptyStateMessage: FC = () => {
  const intl = useIntl()

  useEffect(() => {
    setTimeout(() => {
      TooltipUtils.rebuild()
    }, 0)
  }, [])

  const handleClick = (): void => {
    const route = `/automation/workflow/0/edit?wt=UnsubscriptionCampaign`
    notifyParent('redirectMainFrame', [
      `automation_app_redirector.aspx?r=${encodeURIComponent(route)}`,
    ])
  }

  return (
    <Panel>
      <Flex flexDirection="column" gap="16px">
        <Title variant={TITLE_VARIANT_M}>
          {intl.formatMessage({
            id: 'Load.UnsubscriptionCampaignsList.EmptyStateTitle',
          })}
        </Title>

        <MessageBox variant={MESSAGE_BOX_VARIANT_HELP}>
          {intl.formatMessage(
            { id: 'Load.UnsubscriptionCampaignsList.EmptyStateDescription' },
            {
              link: (chunks) => (
                <Link
                  variant={LINK_VARIANT_HIGHLIGHT}
                  data-mu-test="empty-state__mshop"
                  onClick={handleClick}
                >
                  {chunks}
                </Link>
              ),
            },
          )}
        </MessageBox>
      </Flex>
    </Panel>
  )
}

export default EmptyStateMessage
